import {Text, Link} from '@chakra-ui/react'
import {useTranslation, Trans} from 'react-i18next'

import {
  QANTAS_TERMS_AND_CONDITIONS_URL,
  MARMALADE_PRIVACY_POLICY_URL,
} from './Urls'

const TermsLinks = () => {
  const {t} = useTranslation('points')

  return (
    <Text textStyle="body-small">
      <Trans
        t={t}
        i18nKey="points:qantasConnectionDrawer.termsLinks"
        components={{
          QantasTermsLink: (
            <Link
              textDecoration="underline"
              href={QANTAS_TERMS_AND_CONDITIONS_URL}
              isExternal
            />
          ),
          MarmaladePrivacyPolicyLink: (
            <Link
              textDecoration="underline"
              href={MARMALADE_PRIVACY_POLICY_URL}
              isExternal
            />
          ),
        }}
      />
    </Text>
  )
}

export default TermsLinks
